export default __webpack_public_path__ + "static/media/Acionistas-PT.bcfee6d1.png";